import TakePhoto from '@/modules/TakePhoto';
import useUser from '@authentication/hooks/useUser';
import React from 'react';

function TakePhotoPage() {
  const { setPageTitle } = useUser();

  React.useEffect(() => {
    setPageTitle('Choisissez une couverture (optionnelle)');
  }, []);
  return <TakePhoto />;
}

export default TakePhotoPage;
